( function () {
    'use strict';
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.modal = {};
    e.bootstrap.modal.init = function () {
        jQuery( '.e-modal' ).on( 'show', function () {
            jQuery( this ).addClass( 'e-modal e-modal-fixed' );
            jQuery( 'body' ).addClass( 'e-modal-fixed-backdrop' );
        } ).on( 'hidden', function () {
            jQuery( this ).removeClass( 'e-modal e-modal-fixed' );
            jQuery( 'body' ).removeClass( 'e-modal-fixed-backdrop' );
        } );
    };
}() );
